<template>
    <label class="workflow-label label-padding-on-map-switch mb-1 mr-1 d-flex align-items-center">
        {{ label || 'Unknown' }}
        <sup v-if="showRequiredMark" class="text-danger font-8" v-tooltip="'Field is required'">
            <i class="fa fa-star-of-life"></i>
        </sup>
        <span v-if="isEnabledWorkflowDebugMode && name.length" class="debug-caption ml-1">
            {{ name }}
        </span>
    </label>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'AppParamHeader',
    props: {
        label: {
            type: String,
            default: 'Unknown'
        },
        showRequiredMark: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: '',
            required: false
        }
    },
    computed: {
        ...mapGetters([
            'isEnabledWorkflowDebugMode'
        ])
    }
}
</script>

<style lang="scss" scoped>
    .label-padding-on-map-switch {
        padding-right: 64px;
    }

    .debug-caption {
        border-radius: 5px;
        border: 1px solid;
        font-size: 10px;
        padding: 5px;
    }
</style>
